import { useBalance } from '@puzzlehq/sdk';
import { useMemo } from 'react';

export const useAleoBalance = () => {
  const { balances, loading } = useBalance();
  const creditsBalance = balances?.find(
    (balance) =>
      balance.programId === 'credits.aleo' && balance.symbol === 'ALEO'
  );

  const totalBalance = useMemo(() => {
    if (creditsBalance)
      return creditsBalance.values.private + creditsBalance.values.public;
  }, [JSON.stringify(creditsBalance)]);

  return { creditsBalance, totalBalance, loading };
};

export const usePARCBalance = () => {
  const { balances, loading } = useBalance();
  const parcBalance = balances?.find(
    (balance) => balance.programId === import.meta.env.VITE_COIN_CONTRACT!
  );

  return { parcBalance: parcBalance?.values.private, loading };
};

export const usePARTBalance = () => {
  const { balances, loading } = useBalance();
  const partBalance = balances?.find(
    (balance) => balance.programId === import.meta.env.VITE_TICKET_CONTRACT!
  );

  return { partBalance: partBalance?.values.private, loading };
};
